// 本周每日任务配置
interface MapListWeeklySignTaskConfigVO {
  [key: number]: The0[];
}

export interface The0 {
  /**
   * 活动配置ID
   */
  activityConfigId?: number;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 星期几: 1-周一 2-周二...7-周日
   */
  dayOfWeek?: number;
  /**
   * 主键ID
   */
  id?: number;
  /**
   * 是否是全勤奖励
   */
  isFullReward?: number;
  /**
   * 目标金额
   */
  targetAmount?: number;
  /**
   * 任务类型 1-累计充值 2-累计下注
   */
  taskType?: number;
  /**
   * 更新时间
   */
  updateTime?: string;

  [property: string]: any;
}

/**
 * 活动详情VO
 */
export interface ActivityDetailVO {
  /**
   * 当前日期 时间戳
   */
  currentDate?: number;
  /**
   * 印度时间 星期几
   * */
  indiaDayOfWeek: number;
  /**
   * 用户当前VIP等级
   */
  currentVipLevel: number;
  // 当前vip加成
  currentVipBonusRate: number;
  // 当天下注情况
  dailyBettingAmount: number;
  // 当天充值情况
  dailyRechargeAmount: number;
  // 当前是否已经领取额外奖励
  extraRewardReceived: boolean;
  /**
   * 本周每日签到奖励配置
   */
  dailyRewards?: WeeklyDailyRewardConfigVO[];
  /**
   * 已签到天数
   */
  signedDays?: number;
  /**
   * 本周签到记录
   */
  weekRecords?: UserDailySignRecordVO[];
  // 任务配置
  dailyTasks?: MapListWeeklySignTaskConfigVO;

  [property: string]: any;
}

/**
 * 每日奖励配置VO
 *
 * WeeklyDailyRewardConfigVO
 */
export interface WeeklyDailyRewardConfigVO {
  /**
   * 活动配置ID
   */
  activityConfigId?: number;
  /**
   * 创建人
   */
  createBy?: string;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 星期几: 1-周一 2-周二...7-周日
   */
  dayOfWeek?: number;
  /**
   * 主键ID
   */
  id?: number;
  /**
   * 是否是全勤奖励
   */
  isFullReward?: number;
  /**
   * 包ID
   */
  packageId?: number;
  /**
   * 奖励数值
   */
  rewardAmount?: number;
  /**
   * 奖励类型 1-余额
   */
  rewardType?: number;
  /**
   * 顺序
   */
  sort?: number;
  /**
   * 更新人
   */
  updateBy?: string;
  /**
   * 更新时间
   */
  updateTime?: string;

  [property: string]: any;
}

/**
 * 用户每日签到记录VO
 *
 * UserDailySignRecordVO
 */
export interface UserDailySignRecordVO {
  /**
   * 活动配置ID
   */
  activityConfigId?: number;
  /**
   * 达成状态: 0-未达成 1-已达成
   */
  arriveStatus?: 0 | 1;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 星期几: 1-周一 2-周二...7-周日
   */
  dayOfWeek?: number;
  /**
   * 主键ID
   */
  id?: number;
  /**
   * 包ID
   */
  packageId?: number;
  /**
   * 领取状态: 0-待领取 1-已领取
   */
  receiveStatus?: 0 | 1;
  /**
   * 领取时间
   */
  receiveTime?: string;
  /**
   * 领取的奖励金额（自动领取时有值）
   */
  rewardAmount?: number;
  /**
   * 奖励类型: 1-余额
   */
  rewardType?: number;
  /**
   * 签到日期
   */
  signDate?: string;
  /**
   * 更新时间
   */
  updateTime?: string;
  /**
   * 用户ID
   */
  userId?: number;
  /**
   * vip等级
   */
  vipLevel?: number;
  /**
   * 周编码
   */
  weekCode?: number;

  [property: string]: any;
}

/**
 * 签到状态枚举
 */
export enum CheckInStatus {
  /** 过期 */
  EXPIRED = -1,
  /** 不可签到（未来日期） */
  LOCKED,
  /** 可签到 */
  AVAILABLE,
  /** 已签到但任务未完成 */
  CHECKED_IN,
  /** 已签到且任务完成但未领取奖励 */
  TASK_COMPLETED,
  /** 已签到且已领取奖励 */
  COMPLETED,
}

/**
 * 签到返回VO
 *
 * SignInResultVO
 */
export interface SignInResultVO {
  /**
   * 自动领取的奖励金额（无任务时）
   */
  autoRewardAmount?: number;
  /**
   * 签到记录
   */
  signRecord?: UserDailySignRecordVO;

  [property: string]: any;
}

/**
 * 领取签到奖励返回VO
 *
 * ReceiveRewardVO
 */
export interface ReceiveRewardVO {
  /**
   * 消息
   */
  message?: string;
  /**
   * 奖励金额
   */
  rewardAmount?: number;

  [property: string]: any;
}
